import { onPageReady } from './utils';
import powerbiReport from './modules/powerbi.report.js';

onPageReady(() => powerbiReport.init());
